import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from "../components/Dashboard";
import Public from "../components/Public";
import Login from "../components/Login";
import store from '../store/store'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'Public',
            component: Public
        },
        {
            path: '/add',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        }
    ]
})

router.beforeEach((to, from, next) => {
    if(to.name == "Dashboard" && !(store.getters.isLoggedIn)){
        next("/login")
        return;
    }
    next();
  })

export default router